import moment from "moment";

export const func = {
    formatUrl(img = '') {
        if (img === false) img = '';
        img = img.replace(process.env.VUE_APP_BASE_URL_CMS, process.env.VUE_APP_BASE_URL_FE);
        return img;
    },

    filterByDeliveryMedia(data = [], deliveryType = ['タウンポータル']) {
        let result = [];
        for (let idxData in data) {
            let deliveryMedia = data[idxData]?.acf?.delivery_media || [];
            for(let idxDelivery in deliveryMedia) {
                if (deliveryType.includes(deliveryMedia[idxDelivery])) {
                    result.push(data[idxData]);
                    break;
                }
            }
        }
        return result;
    },

    sortByKey(data = [], sortKey = 'display_order' ) {
        var dataSorted = data.slice().sort(function(a, b){
            var keyA = a.acf[sortKey],
                keyB = b.acf[sortKey];
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });
        return dataSorted;
    },

    sortByNumberKey(data = [], sortKey = 'display_order' ) {
        var dataSorted = data.slice().sort(function(a, b){
            var keyA = Number(a.acf[sortKey]),
                keyB = Number(b.acf[sortKey]);
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });
        return dataSorted;
    },

    sortByPublicDate(data = [], type = 'desc') {
        var dataSorted = data.slice().sort(function(a, b){
            var keyA = a['date'],
                keyB = b['date'];
            // Compare the 2 dates
            if (type === 'desc') {
                if (keyA > keyB) return -1;
                if (keyA < keyB) return 1;
            } else {
                if (keyA < keyB) return -1;
                if (keyA > keyB) return 1;
            }
            return 0;
        });
        return dataSorted;
    },

    filterByStartDateEndDate(data, date) {
        let result = [];
        if (!moment(date, "YYYYMMDD").isValid()) {
            return result;
        }
        for (let idxData in data) {
            if (!data[idxData]?.acf?.event_start_date || !data[idxData]?.acf?.event_end_date) {
                continue;
            }
            const eventStartDate = moment(data[idxData]?.acf?.event_start_date.replaceAll('/', '-')).format("YYYYMMDD");
            const eventEndDate = moment(data[idxData]?.acf?.event_end_date.replaceAll('/', '-')).format("YYYYMMDD");
            if (eventStartDate <= date && date <= eventEndDate) {
                result.push(data[idxData]);
            }
        }
        return result;
    }
}